/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Preset_Save_TitleInputs */



/**
* | output |
* | --- |
* | "Save Transcript Export Preset" |
*
* @param {Transcript_Export_Preset_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_save_title = /** @type {((inputs?: Transcript_Export_Preset_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le prereglage d'exportation de transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkript speichern Exportvorgabe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva trascrizione Esporta preimpostazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить расшифровку Экспорт настроек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar transcripción Exportar ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存转录导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトエクスポートプリセットを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रांसक्रिप्ट निर्यात प्रीसेट सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar transcrição Exportar predefinição")
	return /** @type {LocalizedString} */ ("Save Transcript Export Preset")
});